/*
 * @Author: withease-partner+cao@hashdash-group.com
 * @Description: the frame page of 「内部者添加的组件」
 */
 <template>
  <div class="cInsiderAdd-container">
    <div class="cInsiderAdd-list" v-for="(item, index) in addData" :key="index">
      <div class="cInsiderAdd-head">
        <p class="head-name">内部者登録{{ index + 1 }}</p>
        <p class="head-btn" @click="handeDelete(index)">
          削除 <img src="../../assets/icon/delete_green.svg" alt="" />
        </p>
      </div>
      <div class="cInsiderAdd-main">
        <cInputTitle text="内部者登録区分"></cInputTitle>
        <ul class="company-type">
          <li
            v-for="(it, ind) in companyTypeData"
            :key="ind"
            @click="handelSelectCompany(it, index)"
            class="select-item"
            :class="{
              'select-noactive': item.companyType && item.companyType != it.id,
              'select-active': item.companyType && item.companyType == it.id
            }"
          >
            {{ it.value }}
          </li>
        </ul>
        <section class="add-list">
          <cInputTitle text="内部関係者区分"></cInputTitle>
          <cDropDown
            placeholder="選択してください"
            :value="item.insideType.value"
            @clickbtn="openclose(true, index)"
          ></cDropDown>
        </section>
        <section class="add-list">
          <cInputTitle text="会社の銘柄コード"></cInputTitle>
          <cNumInput
            placeholder="1234"
            v-model="item.code"
            @input="
              (value) => {
                handleInput(value, index);
              }
            "
            oninput="value = value.replace(/[^\d０-９]/g, ''); if (value.length > 4) value = value.slice(0, 4)"
          ></cNumInput>
        </section>
        <section
          class="add-list"
          v-if="
            ([10, 12, 11, 13].includes(item.insideType.id) &&
              item.companyType == 1) ||
            ([4, 10, 5, 11].includes(item.insideType.id) &&
              item.companyType == 2)
          "
        >
          <cInputTitle text="内部者氏名"></cInputTitle>
          <cTextInput
            :placeholder="placeholder"
            v-model.trim="item.name"
          ></cTextInput>
        </section>
      </div>
    </div>
    <section>
      <div v-if="addData.length < 5">
        <cRoundButton
          v-if="showAddBtn && itemIsOver"
          text="登録する会社を追加"
          @clickbtn="handelAdd"
        ></cRoundButton>
        <cRoundButton
          v-if="!showAddBtn"
          text="キャンセル"
          @clickbtn="handelCancel"
        ></cRoundButton>
      </div>

      <p class="cInsiderAdd--tips">
        5社まで登録できます。5社以上の内部者に該当する方は、お問い合わせください。
      </p>
    </section>
    <!-- 内部関係者区分 -->
    <cSinglePopup
      :selectdata="insiderArr"
      :show="showPopup"
      @clickcancel="selectedInsider"
      @clickclose="openclose(false)"
      @clickselect="handelSelectInsider"
    ></cSinglePopup>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      placeholder: '山田 太郎',
      companyTypeData: this.commonData.companyTypeData,
      insiderArr: this.commonData.internalTiesData,
      isInside: {},
      showPopup: false,
      addData: [],
      nowIndex: 0,
      showAddBtn: true
    };
  },
  activated() {
    this.putData();
  },
  created() {
    this.putData();
  },
  watch: {
    itemIsOver(val) {
      if (this.itemIsOver) {
        this.showAddBtn = true;
        this.$emit('getInsideAdd', this.addData);
      }
    }
  },
  computed: {
    itemIsOver() {
      let status = this.addData.every((item) => {
        let a = Object.keys(item.insideType).length != 0;
        if (item.companyType == 1) {
          if ([10, 12, 11, 13].includes(item.insideType.id)) {
            return a && item.code && item.name && !item.formatErrorCode;
          } else {
            return a && item.code && !item.formatErrorCode;
          }
        } else if (item.companyType == 2) {
          if ([4, 10, 5, 11].includes(item.insideType.id)) {
            return a && item.code && item.name && !item.formatErrorCode;
          } else {
            return a && item.code && !item.formatErrorCode;
          }
        }
      });
      return status;
    }
  },
  methods: {
    putData() {
      this.addData = this.data;
      if (this.addData.length == 0) {
        this.addData = [
          {
            companyType: '',
            insideType: {},
            code: '',
            formatErrorCode: false,
            name: ''
          }
        ];
      }
    },
    handeDelete(index) {
      if (this.addData.length == 1) {
        this.addData = [
          {
            companyType: '',
            insideType: {},
            code: '',
            formatErrorCode: false,
            name: ''
          }
        ];
      } else {
        this.addData.splice(index, 1);
      }
    },
    handelAdd() {
      if (this.addData.length < 5) {
        this.addData.push({
          companyType: '',
          insideType: {},
          code: '',
          formatErrorCode: false,
          name: ''
        });
        this.showAddBtn = false;
      }
    },
    handelCancel() {
      this.showAddBtn = true;
      this.addData.splice(this.addData.length - 1, 1);
    },
    // 选择公司种类
    handelSelectCompany(item, index) {
      this.commonData.internalTiesData = this.commonJs.clearSelected(
        this.commonData.internalTiesData
      );
      this.commonData.internalTiesData1 = this.commonJs.clearSelected(
        this.commonData.internalTiesData1
      );
      this.commonData.companyTypeData = this.commonJs.clearSelected(
        this.commonData.companyTypeData
      );

      this.addData[index].companyType = item.id;
      this.addData[index].insideType = {};
    },
    handleInput(value, index) {
      this.addData[index].formatErrorCode = !(value.length == 4);
    },
    // 打开弹框
    openclose(falg, index) {
      this.showPopup = falg;
      if (falg) {
        this.nowIndex = index;
        if (this.addData[index].companyType) {
          this.insiderArr =
            this.addData[index].companyType == 1
              ? this.commonData.internalTiesData
              : this.commonData.internalTiesData1;
        } else {
          this.showAlert('タイプを選択してください');
          this.showPopup = false;
        }
      }
    },
    handelSelectInsider(item) {
      this.insiderArr = this.commonJs.clearSelected(this.insiderArr);
      item.isActive = true;
    },
    selectedInsider(falg) {
      if (falg) {
        var status = this.insiderArr.find((ite) => {
          return ite.isActive;
        });
        this.addData[this.nowIndex].insideType = status;
      } else {
        this.insiderArr = this.commonJs.clearSelected(this.insiderArr);
        this.selectData[this.nowIndex].insiderType = {};
      }
    },
    showAlert(msg) {
      var that = this;
      that.$cErrorDialog({
        title: '',
        left: 'cancel',
        right: 'OK',
        content: msg,
        cancelBtn: false //这个是启用取消按钮，
      });
    }
  }
};
</script>

<style lang="less"  scoped>
.cInsiderAdd-container {
  margin-top: 0.2rem;
  .cInsiderAdd-list {
    margin-bottom: 0.2rem;
    border: 2px solid #00a4b0;
    border-radius: 0.05rem;
    .cInsiderAdd-head {
      height: 0.5rem;
      background: #00a4b0;
      display: flex;
      padding: 0 0.2rem;
      align-items: center;
      font-size: 0.16rem;
      font-weight: bold;
      color: #fff;
      justify-content: space-between;
      box-sizing: border-box;
      .head-btn {
        width: 0.65rem;
        height: 0.32rem;
        background: #ffffff;
        border-radius: 0.1rem;
        color: #00a4b0;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        img {
          width: 0.12rem;
          height: 0.12rem;
          margin-left: 0.05rem;
        }
      }
    }
    .cInsiderAdd-main {
      padding: 0.22rem 0.2rem;
      box-sizing: border-box;
      .company-type {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .select-item {
    cursor: pointer;
          width: 100%;
          height: 0.5rem;
          line-height: 0.5rem;
          text-align: center;
          font-size: 0.16rem;
          color: var(--text-blackcolor);
          background-color: var(--bg-pinkcolor);
          border: 2px solid var(--maincolor);
          border-radius: 0.05rem;
          margin-bottom: 0.11rem;
          font-weight: bold;
        }
        .select-noactive {
          color: var(--text-graycolor);
          border: 1px solid var(--text-graycolor);
          background-color: #fff;
          font-weight: normal;
        }
        .select-active {
          font-weight: normal;
          background-color: var(--maincolor);
          color: #fff;
        }
      }
    }
    .add-list {
      margin-top: 0.2rem;
    }
  }
  .cInsiderAdd--tips {
    margin-top: 0.2rem;
    font-size: 0.16rem;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Container/cInsiderAdd.vue